<template>
  <div class="main-content">
    <div>
      <b-row class="mb-16">
        <b-col md="8">
          <h2 class="page-title">
            <!-- <small v-if="userIsAdmin && this.$route.params.role !== 'all'">
              <nuxt-link
                tag="a"
                class
                :to="`/team/${$route.params.role}/adduser`"
              >
                <i class="nav-icon i-Add"></i>
                <span class="item-name"> Add New</span>
              </nuxt-link>
            </small> -->
          </h2>
        </b-col>
        <b-col md="4">
          <b-form-input
            v-model="searchWord"
            class="form-control-rounded"
            type="text"
            required
            placeholder="Search..."
          >
          </b-form-input>
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col v-for="item in 4" :key="item" md="3">
          <loadingSkeleton />
        </b-col>
      </b-row>
      <div v-show="!loading" v-if="constrcuting">
        <keep-alive>
          <transition-group name="fade" tag="b-row">
            <b-col
              v-for="user in filteredUsers"
              v-show="searchUser(user)"
              :key="user.id"
              lg="3"
              sm="6"
              md="4"
              class="user-card"
            >
              <UserBlock :user="user" />
            </b-col>
          </transition-group>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/utils"
// import flickity from "vue-flickity"
import loadingSkeleton from "@/components/teammember/loadSkeleton"
import UserBlock from "@/components/teammember/userBlock"

export default {
  layout: "default",
  components: {
    // flickity,
    UserBlock,
    loadingSkeleton
  },
  apollo: {
    users: {
      query: require("@/graphql/Account/GetUsersWithTimeLogs.gql"),
      update(data) {
        setTimeout(() => {
          this.constrcuting = true
          this.$nextTick(() => {
            this.loading = false
          })
        }, 1000)
        return data.users
      }
    }
  },
  data() {
    return {
      name: "",
      position: "",
      loading: true,
      constrcuting: false,
      searchWord: "",
      slider: {
        options: {
          pageDots: false,
          wrapAround: true,
          adaptiveHeight: true,
          prevNextButtons: false
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getCurrentUser: "getCurrentUser"
    }),

    filteredUsers() {
      //The map is here because of an annoying error
      return this.users
        .map(x => x)
        .sort((a, b) =>
          a.firstName > b.firstName && a.firstName !== "**Unassigned**" ? 1 : -1
        )
    },
    userIsAdmin() {
      if (!this.getCurrentUser) return false
      let roles = this.getCurrentUser.roles
      return roles.includes("Admin") || roles.includes("Super Admin")
    }
  },
  methods: {
    /**
     * Searches based on user first and last name
     * @param user
     * @returns {boolean | string}
     */
    searchUser(user) {
      return (
        user.firstName?.includesLowerCase(this.searchWord) ||
        user.lastName?.includesLowerCase(this.searchWord)
      )
    },
    /**
     * Gets incomplete task count
     * @param tasks
     * @returns {*}
     */
    getTasksCount(tasks) {
      return tasks.filter(x => !x.completed)?.length ?? 0
    },
    toLink(projectName) {
      return Util.stringToLink(projectName)
    }
  }
}
</script>

<style scoped>
.user-card {
  margin-bottom: 15px;
}
.inline {
  display: inline-block;
}
.b-dropdown {
  position: absolute;
  right: 0;
  top: 0;
}
.greyed {
  background: #eeeeee;
}
.thin {
  padding: 5px 10px;
  font-size: 12px;
}
.carousel-cell {
  width: 100%;
}
.project-stats {
  text-align: left;
  max-width: 250px;
  margin: auto;
  margin-bottom: 10px;
}
.project-stats:last-child {
  margin-bottom: 0px !important;
}
.project-stats p {
  margin: 0;
}
.project-stats .details p {
  float: right;
  font-size: 75%;
  padding-right: 0px !important;
}
.project-stats .details * {
  padding: 5px 10px !important;
}
.overdue {
  color: red;
  font-weight: bold;
}
.avatar {
  min-height: 16vh;
}
.badge {
  white-space: unset !important;
}
.ticket {
  color: darkmagenta;
}
.numbers-grid {
  display: grid;
  grid-template-areas: "tasksArea ticketsArea timeArea";
  grid-template-columns: 3fr 3fr 7fr;

  /* margin-bottom: 2rem; */
}

.tasks-area {
  grid-area: tasksArea;
  padding: 0.02rem;
  white-space: nowrap;
}

.tickets-area {
  grid-area: ticketsArea;
  padding: 0.02rem;
  white-space: nowrap;
}

.time-area {
  grid-area: timeArea;
  text-align: right;
  margin-right: 0.5rem;
}

.time-row {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.no-padding {
  padding: 0 !important;
  text-align: left;
}

.underlogged {
  font-weight: bold;
  color: red;
}

/* .time-row {
  display: flex;
  flex-direction: column;
} */
.overdue-row {
  text-align: center;
  margin-bottom: 0.5rem;
}
.leave-row {
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.badge-item {
  margin: auto !important;
}

.clock-custom {
  vertical-align: text-bottom;
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

@media (min-width: 1500px) {
  .no-time-log {
    margin: 1.6rem !important;
  }
}
.no-time-log {
  margin: 1.3rem;
}
.no-overdue {
  margin: 0.5rem;
}
.no-items {
  margin: 1.1rem;
}
.no-margin {
  margin: 0 !important;
}
.user-name {
  font-weight: bold;
}
</style>
